import { motion } from "framer-motion";

const Contact = () => {
    return (
        <section
            id="contact"
            className="relative bg-gradient-to-br from-gray-900 via-slate-900 to-gray-800 text-white py-24 px-6 overflow-hidden"
        >
            {/* 背景大光晕 */}
            <div className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-1/3 w-[600px] h-[600px] bg-indigo-500/20 blur-[150px] rounded-full pointer-events-none z-0"></div>

            <div className="relative max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-20 items-center z-10">
                {/* 左侧文字 */}
                <motion.div
                    initial={{ opacity: 0, x: -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    <h2 className="text-4xl font-extrabold mb-6 text-indigo-400">
                        联系我们
                    </h2>
                    <p className="text-slate-300 text-base mb-8 leading-relaxed max-w-md">
                        有 API 接入、SLA 保证、专属技术支持或私有部署需求？
                        欢迎通过以下方式联系我们，我们将在
                        <span className="text-indigo-300"> 1 个工作日内响应</span>。
                    </p>

                    <div className="space-y-6 text-sm">
                        <div>
                            <p className="text-gray-400">📧 邮箱</p>
                            <a
                                href="mailto:hi@setonink.com"
                                className="text-indigo-300 underline hover:text-indigo-100 transition"
                            >
                                hi@setonink.com
                            </a>
                        </div>
                        <div>
                            <p className="text-gray-400">📞 电话</p>
                            <p>400-026-2810</p>
                        </div>
                        <div>
                            <p className="text-gray-400">🕒 服务时间</p>
                            <p>工作日 9:00 - 18:00</p>
                        </div>
                    </div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.4 }}
                        viewport={{ once: true }}
                        className="mt-10"
                    >
                        <a
                            href="mailto:hi@setonink.com"
                            className="inline-block bg-indigo-600 hover:bg-indigo-500 text-white font-medium py-3 px-8 rounded-full shadow-lg transition"
                        >
                            发送邮件咨询
                        </a>
                    </motion.div>
                </motion.div>

                {/* 右侧展示大图/大圆/品牌元素 */}
                <motion.div
                    initial={{ opacity: 0, x: 40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="flex justify-center"
                >
                    <div className="relative w-80 h-80 rounded-full bg-gradient-to-tr from-indigo-500 via-purple-500 to-indigo-400 shadow-xl flex items-center justify-center">
                        <p className="text-white text-lg font-medium text-center px-4 leading-relaxed">
                            Seton DNS
                            <br />
                            企业级 DNS 解决方案
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default Contact;